import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import withWidth, { isWidthUp } from '@mui/material/Hidden/withWidth'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React from 'react'
import questionMarkBlue from 'src/assets/images/common/questionMarkBlue.svg'
import { checkMobileDevice } from 'src/utils/utils/commonUtils'

function TooltipInfoContent({ data, title, width, keywords = [] }) {
  const theme = useTheme()
  return (
    <Box
      px={{ xs: 6.5, sm: 2 }}
      pt={{ sm: 1 }}
      pb={{ sm: 2 }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {isWidthUp('sm', width) && !checkMobileDevice() && (
        <Box sx={{ display: 'flex', margin: '0 0 16px 8px', width: '100%' }}>
          <img src={questionMarkBlue} alt='' />
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: '500',
              color: theme.palette.text.graySemidark,
              marginLeft: '8px',
            }}
          >
            {title}
          </Typography>
        </Box>
      )}

      {Array.isArray(data) &&
        !!data &&
        data?.map((text) => {
          return (
            <Typography
              variant={'body1'}
              sx={{
                marginBottom: '8px',
                textAlign: 'center',
                color: theme.palette.text.graySemidark,
              }}
              key={text}
            >
              {getHighlightedText(text, keywords)}
            </Typography>
          )
        })}
      {!Array.isArray(data) && !!data?.length && (
        <Typography
          variant={'body1'}
          sx={{
            marginBottom: '8px',
            textAlign: 'center',
            color: theme.palette.text.graySemidark,
          }}
        >
          {getHighlightedText(data, keywords)}
        </Typography>
      )}
    </Box>
  )
}

const getHighlightedText = (text, keywords) => {
  if (typeof text !== 'string') {
    return text
  }
  const regex = new RegExp(`(${keywords.join('|')})`, 'g')

  const parts = text.split(regex)

  return parts.map((part, index) =>
    keywords.includes(part) ? <strong key={index}>{part}</strong> : part
  )
}

export default withWidth()(observer(TooltipInfoContent))
